import { Workbox } from 'workbox-window';

if ('serviceWorker' in navigator) {
  const url = document.currentScript.getAttribute('data-service-worker-url');
  const wb = new Workbox(url);

  wb.addEventListener('controlling', (event) => {
    document.getElementById('splashscreen').style.display = 'flex'
    requestAnimationFrame(()=>{
      window.location.reload(true)
    });
  })

  const register = wb.register();
  window._CACHE_URLS = async (urlsToCache) => {
    const registration = await register
    if (registration.active) {
      registration.active.postMessage({
        type: 'CACHE_URLS', 
        payload:{urlsToCache}
      })
    }
  } 

}
